import { ThemeType } from '../enums/config';

const themes = {
	[ThemeType.default]: {
		name: 'default',
		bodyBackgroundColor: '#000080',
		mobileTitle: 'View people who have already swiped up on you!',
		lockupLogoName: 'mutual-logo.png',
		timer: {
			text:"",
			isEnabled: true
		},
		bannerName: {
			mobile: "",
			desktop:""
		},
		reStyled: {
			borderRadius: 20,
			backgroundColor: '#FFFFFF',
			color: '#454545',
			border: '2px solid #FFFFFF',
			boxShadow: 'none'
		},
		puchaseButtonBackgroundColor: '#FF3363',
		title: 'Exclusive Online Offers',
		subtitle:
			'For a limited time only, save on Mutual’s premium features when you purchase online!',
		billingTextColor: '#6D6E71',
		monthlyTextColor: '#FF3363'
	},
};

export default themes;
